import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { ActiveColorsIndicator } from 'common/Prose/components/ActiveColorsIndicator/ActiveColorsIndicator'
import Styles from './ActiveColorIcon.module.scss'
import { TextColor } from 'blaze-ui/icons'
import { IconProps } from 'blaze-ui/icons/Types'

export const TextColorIcon = observer(({ size }: Pick<IconProps, 'size'>) => {
  const editorState = useContext(AlmanacEditorStateContext)
  const activeColors = computed(() => editorState?.activeColors && Array.from(editorState.activeColors)).get() || []

  return (
    <div className={Styles.wrapper}>
      <TextColor size={size} />
      <ActiveColorsIndicator colors={activeColors} className={Styles.indicator} />
    </div>
  )
})
